class Dragabelizer{
    init(){
        this._draggedNode = null;
        this._draggerOffset = { x: 0, y: 0 };
        document.addEventListener("mouseleave", this.endDrag.bind(this));
        document.addEventListener("mouseup", this.endDrag.bind(this));
        document.body.addEventListener("mousemove", this.onDrag.bind(this));
    }

    dragablizeNode(node){
        let dragger = node.querySelector('[dragHandle]');
        if (!dragger) {
            return;
        }
        node.style.position = "absolute";
        dragger.addEventListener("mousedown", (e) => {
            this._draggedNode = node;
            this._draggerOffset.x = e.offsetX;
            this._draggerOffset.y = e.offsetY;
           
        });
        dragger.addEventListener("mouseup", this.endDrag.bind(this));
    }

     onDrag(e) {
      
        if ( this._draggedNode) {
            this._draggedNode.style.top = `${e.clientY - this._draggerOffset.y}px`;
            this._draggedNode.style.left = `${e.clientX - this._draggerOffset.x}px`;
        }
    }
     endDrag() {
        this._draggedNode = null;
    }
}


const initFunctions = {
    'alt-translation': function (node, dataSource) {
        node.innerHTML = dataSource.data[node.getAttribute('data-translation')]||'';

    },
    translation: function applyTranslations(node, dataSource){

        node.querySelectorAll('[data-translation]').forEach((tNode) => {
            tNode.innerHTML = dataSource.data.row[tNode.getAttribute('data-translation')]||'';
        });
    },
    remove: function (node) {
        if (node.parentNode) {
            node.parentNode.removeChild(node);
        }
    },
    draggablelize: function (node) {
        if (!window.draggablelize) {
            window.draggablelize = new Dragabelizer();
            window.draggablelize.init();
        }

        window.draggablelize.dragablizeNode(node);
        
    }
};

export default initFunctions;











